const GET_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST =
  'GET_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST';
const GET_VALIDATED_RC_SCANNED_DOCUMENTS_SUCCESS =
  'GET_VALIDATED_RC_SCANNED_DOCUMENTS_SUCCESS';
const GET_VALIDATED_RC_SCANNED_DOCUMENTS_ERROR =
  'GET_VALIDATED_RC_SCANNED_DOCUMENTS_ERROR';

const DELETE_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST =
  'DELETE_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST';
const DELETE_VALIDATED_RC_SCANNED_DOCUMENT_SUCCESS =
  'DELETE_VALIDATED_RC_SCANNED_DOCUMENT_SUCCESS';
const DELETE_VALIDATED_RC_SCANNED_DOCUMENT_ERROR =
  'DELETE_VALIDATED_RC_SCANNED_DOCUMENT_ERROR';

const CLEAR_VALIDATED_RC_SCANNED_DOCUMENTS_STATE =
  'CLEAR_RC_SCANNED_DOCUMENTS_STATE';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
const INIT_REDUCER = 'INIT_REDUCER';
const CREATE_ERRORS = 'CREATE_ERRORS';

export {
  GET_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST,
  GET_VALIDATED_RC_SCANNED_DOCUMENTS_SUCCESS,
  GET_VALIDATED_RC_SCANNED_DOCUMENTS_ERROR,
  DELETE_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST,
  DELETE_VALIDATED_RC_SCANNED_DOCUMENT_SUCCESS,
  DELETE_VALIDATED_RC_SCANNED_DOCUMENT_ERROR,
  CLEAR_VALIDATED_RC_SCANNED_DOCUMENTS_STATE,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  CREATE_ERRORS,
  INIT_REDUCER,
};
